module.exports = __webpack_public_path__ + "static/media/responsive-design.eb299d0a.jpg";